import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=70ca0c8c&scoped=true"
import script from "@/controllers/businessInfo.js?vue&type=script&lang=js&external"
export * from "@/controllers/businessInfo.js?vue&type=script&lang=js&external"
import style0 from "./BusinessInfo.styles.scss?vue&type=style&index=0&id=70ca0c8c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca0c8c",
  null
  
)

export default component.exports